const clean = (s) => s.replace(/\*\*/g, '').replace(/^#+\s*/, '');

export const AiText = ({ text, testid }) => {
  const lines = (text || '').split('\n');
  return (
    <div className="space-y-1.5 text-sm leading-relaxed" data-testid={testid}>
      {lines.map((raw, i) => {
        const line = clean(raw.trim());
        if (!line) return <div key={i} className="h-1" />;
        if (/^[-•]\s+/.test(line)) {
          return (
            <div key={i} className="flex gap-2 pl-1">
              <span className="text-primary mt-[3px]">•</span>
              <span>{line.replace(/^[-•]\s+/, '')}</span>
            </div>
          );
        }
        if (line.endsWith(':') && line.length < 70) {
          return <div key={i} className="font-display font-semibold text-foreground pt-2">{line.slice(0, -1)}</div>;
        }
        return <p key={i}>{line}</p>;
      })}
    </div>
  );
};
